// extracted by mini-css-extract-plugin
export default {"card":"styles_card__dhv04","item_text":"styles_item_text__CRxKR","item_icon":"styles_item_icon__vf9HQ","weight":"styles_weight__tmazr"};